import { endpoints } from "@/lib/api/endpoints";
import { useApiQuery } from "@/shared/queries";

/**
 * The query key the store profile is read under — shared with the logo field
 * in Settings, so a new logo reaches the sidebar without a reload.
 */
export const STORE_PROFILE_KEY = ["seller", "store"] as const;

/**
 * THE RESTAURANT'S LOGO, or null when it has none (founder, 2026-10-06: "if
 * there is a logo it is supposed to reflect").
 *
 * `GET /seller/store` needs no permission beyond membership, so every role can
 * read it. A failed read is a missing logo, never an error: the brand falls
 * back to the restaurant's initial.
 */
export function useStoreLogo(enabled = true): string | null {
  const store = useApiQuery<{ logoUrl: string | null }>(
    STORE_PROFILE_KEY,
    endpoints.seller.store,
    { enabled, retry: false, staleTime: 5 * 60_000 },
  );
  return store.data?.logoUrl ?? null;
}
